var config = require("./config");

var utils = {}
utils.waitForRequests=[];

utils.generateGuid = function() {
    return 'abababab_abab_4aba_baba_abababababab'.replace(/[ab]/g, function(ch) {
        var digit = Math.random()*16|0, newch = ch == 'a' ? digit : (digit&0x3|0x8);
        return newch.toString(16);
    }).toUpperCase();
};
// 整理出url中host,protocol,pathname,search等信息
utils.parseURL = function(url) {

    //原地址保存一下
    var locn = { 'href' : url };

    //分割地址
    var urlParts = url.replace('//', '/').split('/');

    //协议
    locn.protocol = urlParts[0];

    if (urlParts.length > 1 ) {

        locn.host = urlParts[1];

        //extract port number from the host
        urlParts[1] = urlParts[1].split(':');
        locn.hostname = urlParts[1][0];
        locn.port = urlParts[1].length > 1 ? urlParts[1][1] : '';

        //splice and join the remainder to get the pathname
        urlParts.splice(0, 2);
        locn.pathname = '/' + urlParts.join('/');

        //extract hash
        locn.pathname = locn.pathname.split('#');
        locn.hash = locn.pathname.length > 1 ? '#' + locn.pathname[1] : '';
        locn.pathname = locn.pathname[0];

        // extract search query
        locn.pathname = locn.pathname.split('?');
        locn.search = locn.pathname.length > 1 ? '?' + locn.pathname[1] : '';
        locn.pathname = locn.pathname[0];

    }

    return locn;
}

utils.matchDomains = function( loc, domains ) {
    return (new RegExp( "(" + domains.join('|').replace(/\./g,'\\.').replace(/\*/g,'\\w+') + ")" )).test( loc );
}

/**
 * 按照ignoreArr中的过滤url中get参数的key
 * @param  {[type]} loc       [description]
 * @param  {[type]} ignoreArr [description]
 * @return {[type]}           [description]
 */
utils.stripQueries = function( loc,ignoreArr ) {
    var queries = {};
    // Use the String::replace method to iterate over each
    // name-value pair in the query string.
    loc.search.replace(
    new RegExp( "([^?=&]+)(=([^&]*))?", "g" ),
    // For each matched query string pair, add that
    // pair to the URL struct using the pre-equals
    // value as the key.
        function( $0, $1, $2, $3 ){
            // Only if the key is NOT in the ignore list should we pick it up
            if (ignoreArr.indexOf($1.toLowerCase()) == -1) {
                queries[ $1 ] = $3;
            }
        }
    );

    var search = "";
    for (var key in queries) {
        search += ( search.length === 0 ? "?" : "&" ) + key + "=" + queries[key];
    };

    // Rebuild the url
    return  ( loc.protocol + loc.host + loc.pathname )
        +   ( loc.search != ("") ? search : "" )
        +   ( loc.hash != ("") ? loc.hash : "" );
}

utils.requestRemote = function(paramObj){
    var i = ++config.err_i;
    if(!config.guid){
        config.guid = utils.generateGuid();
    }
    var guid = config.guid;
    var url = encodeURIComponent(window.location.href);
    var uidal = utils.getCookie("uidal");
    var uid = "";
    if(uidal){
        uid = uidal.substr(0,16);
    }else{
        uid = '';
    }
    paramObj['guid']=guid;//每次页面运行统一ID
    paramObj['url']=url;//当前url
    paramObj['i']=i;//日志请求计数
    paramObj['jv']=config.version;//日志js版本
    paramObj['uid']=uid;//用户uid
    paramObj['mt']=Math.random();//请求随机数
    // paramObj['purl']=document.referrer&&document.referrer!==location.href?document.referrer:''//来源页
    //config.remoteUrl;
    var paramStr = utils.objToStr(paramObj);
    var src = config.remoteUrl+"?"+paramStr;
    utils.appendImg(i,src);
}

utils.appendImg = function(index,src){
    var data = window['xlog_imgLogData'] || (window['xlog_imgLogData'] = {});  
    var img = new Image();  
    var uid = index;
    data[uid]=img;
    img.onload = img.onerror = function () {//销毁一些对象  
        img.onload = img.onerror = null;  
        img = null;  
        delete data[uid];  
    }
    img.src = src;
    
    // var fakeImgId = "xlog_fake_img_"+index;
    // var fakeImgClass = "xlog_fake_img";
    // //var fakeImage=document.getElementById(fakeImgId);
    // var fakeImage = document.createElement('img');
    // fakeImage.setAttribute("class", fakeImgClass); 
    // fakeImage.setAttribute("id",fakeImgId);
    // fakeImage.style.position="absolute";
    // fakeImage.style.left="-10000px";
    // fakeImage.style.top="-10000px";
    // fakeImage.style.display="none";
    // fakeImage.setAttribute("data-src",src);
    // utils.addEventHandler(fakeImage,"load",function(evt){
    //     var target = evt.srcElement ? evt.srcElement:evt.target;
    //     target.parentNode.removeChild(target);
    // })
    
    // if(document.body){
    //     utils.launchFakeImg(fakeImage);
    // }else{//加入执行队列,等onready之后再统一处理
    //     utils.waitForRequests.push(fakeImage);
    // }
}

utils.launchFakeImg=function(domObj){
    var src = domObj.getAttribute("data-src");
    domObj.setAttribute("src",src);
    document.body.appendChild(domObj);
}

utils.onDomReady = function(cb){
    var ie = !!(window.attachEvent && !window.opera);
    if (!ie && document.addEventListener)
        document.addEventListener('DOMContentLoaded', cb, false);
    if (ie){
        (function() {
            try { document.documentElement.doScroll('left'); cb(); }
            catch (err) { setTimeout(function(){
                cb();
            }, 0); }
        })();       
    }
}

utils.checkWait=function(){
    while(utils.waitForRequests.length){
        utils.launchFakeImg(utils.waitForRequests.shift());
    }
}

//头部插入script标签
// utils.appendScript = function(index, src) {
//     try {
//         var script  = document.createElement("script"),
//             head    = document.getElementsByTagName("head")[0];

//         script.id = config.pre+"_script" + index;
//         script.src = src;
//         script.type = "text/javascript";

//         head.appendChild(script);
//     } catch (e) {
//         utils.errorHandler("appendScript", e);
//     }
// };

//日志内部错误处理函数
utils.errorHandler = function(source, error, logger) {
    var message = logger+" encountered an unexpected error.\n\nSource: " + source + "\nDescription: " + error;
    console.log( message );                
};

//这里主要是给远端那个日志js加载后执行的,为了删除掉当前上报后的script标签
// utils.removeScript = function(index) {
//     try {
//         var script  = document.getElementById(config.pre+"_script" + index),
//             head    = document.getElementsByTagName("head")[0];
//         head.removeChild(script);
//     } catch (e) {
//         utils.errorHandler("removeScript", e);
//     }
// };

//添加元素事件
utils.addEventHandler = function(oTarget, sEventType, fnHandler,useCapture) {
    if (oTarget.addEventListener) {
        oTarget.addEventListener(sEventType, fnHandler,useCapture);
    } else if (oTarget.attachEvent) {
        oTarget.attachEvent("on" + sEventType, fnHandler);
    } else {
        oTarget["on" + sEventType] = fnHandler;
    }
    return fnHandler;
};
//移除元素事件
utils.removeEventHandler = function(oTarget, sEventType, fnHandler,useCapture) {
    if (oTarget.removeEventListener) {
        oTarget.removeEventListener(sEventType, fnHandler,useCapture);
    } else if (oTarget.detachEvent) {
        oTarget.detachEvent("on" + sEventType, fnHandler);
    } else { 
        oTarget["on" + sEventType] = null;
    }
};
//转换map类结构变成key1=value1&key2=value2zifuchuan
utils.nodeXmlToStr=function(mapObj){
    var arr = [];
    var len = mapObj.length;
    for(var i=0;i<len;++i){
        var obj = mapObj[i];
        if(typeof(obj)=="object"){
            var name = obj.name;
            var value = obj.value;
            arr.push(name+"="+value);
        }
    }
    return arr.join("&");
}
utils.nodeXmlToObject=function(mapObj){
    var arr = [];
    var len = mapObj.length;
    var obj = {}
    for(var i=0;i<len;++i){
        var obj = mapObj[i];
        if(typeof(obj)=="object"){
            var name = obj.name;
            var value = obj.value;
            obj[name]=value;
        }
    }
    return obj
}
utils.objToStr=function(obj){
    var arr = [];
    for(var k in obj){
        arr.push(k+"="+obj[k]);
    }
    return arr.join('&');
}

utils.encode=function(paramStr){
    return encodeURIComponent(paramStr);
}

/*cookie 操作*/
//拿cookie
utils.getCookie=function(name)
{
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    if(arr=document.cookie.match(reg))
        return decodeURIComponent(arr[2]);
    else
        return null;
}

utils.getQueryString=function(name,url) {
    if(url){
        url = url.indexOf("?")>=0?'?'+url.split("?")[1]:"";
    }else{
        url = window.location.search;
    }
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
    var r = url.substr(1).match(reg); 
    if (r != null) return r[2]; return null; 
} 

//获取自身js加载路径
utils.getSelfUrl=function(myName){
    var scripts = document.getElementsByTagName('script');
    // 获取现在已经加载的所有script
    if(scripts.length>0)
    {
        var lastScript = scripts[scripts.length-1]
        var src = lastScript.src.toLowerCase()
        if(src.indexOf(myName)>=0){
            return src;
        }else{
            var len = scripts.length
            for(var i=0;i<len;++i){
                src = scripts[i].src.toLowerCase()
                if(src.indexOf(myName)>=0){
                    return src;
                }
            }
        }
    }
    return "";
}

//是否取样
utils.willHandle=function(sample){
    var rnd = Math.random()*sample>>0;
    if(rnd==0){
        return true;
    }
    return false;
}

utils.log=function(msg){
    if(config.isDevelop){
        console.log(msg)
    }
}

utils.isIE=function(){
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf("Opera") > -1;
    if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
        return true;
    }else{
        return false;
    }
}

module.exports = utils;


//////////////////
// WEBPACK FOOTER
// ./src/utils.js
// module id = 1
// module chunks = 0 1 2